export const getListingLabel = (listing: {
  listing_id: string
  unit_number?: string
  address: string
  city?: string
  state?: string
}) => {
  let returnString = ''
  const unitText = `${listing.unit_number} - `
  if (listing?.unit_number) {
    returnString += unitText
  }
  return (returnString += `${listing?.address}, ${listing?.city}, ${listing?.state}`)
}
